var $ = require("jquery");
require("slick-carousel");
import "../stylesheets/slider";
import "../stylesheets/slick";
/***** -----------------------------
スライド用
----------------------------- ******/
$(document).ready(function () {
  $(".js-detail-slider-front").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="offices-detail-slide-front__arrow offices-detail-slide-front__arrow--prev">前へ</button>',
    nextArrow:
      '<button type="button" class="offices-detail-slide-front__arrow offices-detail-slide-front__arrow--next">次へ</button>',
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          arrows: false
        }
      }
    ]
  });

  $(".js-detail-modal-slider-front").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="modal-slide-front__arrow modal-slide-front__arrow--prev">前へ</button>',
    nextArrow: '<button type="button" class="modal-slide-front__arrow modal-slide-front__arrow--next">次へ</button>'
  });
});

// スクロール禁止状態にする
function htmlFix() {
  var st = $(window).scrollTop() * -1;
  $("html").addClass("is-fixed");
  $("body").css("top", st);
}

//スクロール禁止状態を解除する
function htmlScroll() {
  var st = parseFloat($("body").css("top")) * -1;
  $("html").removeClass("is-fixed").scrollTop(st);
  $("body").removeAttr("style");
}

//モーダル内スライダー

function modalSlider() {
  $(document).on("click", ".js-modal-slide-trigger", function () {
    var slickSlide = $(this).closest(".slick-slide");
    var slickIndex = slickSlide.attr("data-slick-index");
    $(".js-detail-modal-slider-front").slick("slickGoTo", slickIndex, true);
  });
}

$(function () {
  const $modalTrigger = $(".js-modal-slide-trigger"),
    $modalClose = $(".js-modal-slide-close"),
    $modal = $(".js-modal-slide-target"),
    $overlay = $(".js-overlay-bg");

  // モーダルを開く処理
  $modalTrigger.on("click", function (e) {
    e.preventDefault();

    const target = $($(this).attr("href"));

    target.addClass("is-active");
    $overlay.addClass("is-active");
    htmlFix();
    modalSlider();
  });

  // モーダルを閉じる処理
  $modalClose.on("click", function () {
    $modal.removeClass("is-active");
    $overlay.removeClass("is-active");
    htmlScroll();
  });
});
